import client from '@cryptosheets/feathers-client';
var FEATHERS_TRANSPORT = process.env.REACT_APP_FEATHERS_TRANSPORT || 'socket';
export default client('localStorage', FEATHERS_TRANSPORT);